import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { CapacitorHttp } from '@capacitor/core';

@Injectable({ providedIn: 'root' })
export class OidcHttpService {
  constructor(private readonly httpClient: HttpClient) {}

  get<T>(url: string, accessToken: string): Observable<T> {
    const headers = this.prepareHeaders(accessToken);
    const params = new HttpParams();

    return this.httpClient.get<T>(url, {
      headers,
      params,
    });
  }

  /**
   * Effectue un appel HTTP POST en utilisant l'API `CapacitorHttp`.
   * Il permet d'envoyer des requêtes quand l'application est en arrière plan
   * car le client HTTP d'Angular ne fonctionne pas après 5 minutes en arrière plan
   *
   * Cette méthode envoie les données fournies dans le corps de la requête
   * avec l'en-tête `Content-Type: application/x-www-form-urlencoded`.
   *
   * @param {string} url - L'URL de la requête.
   * @param {any} body - Les données à inclure dans le corps de la requête.
   */
  postCapacitorHttp(url: string, body: any) {
    return from(
      CapacitorHttp.post({
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        url: url,
        data: body,
      })
    );
  }

  post<T>(url: string, body: any): Observable<T> {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');
    const params = new HttpParams();

    return this.httpClient.post<T>(url, body, { headers, params });
  }

  private prepareHeaders(token?: string): HttpHeaders {
    let headers = new HttpHeaders();

    headers = headers.set('Accept', 'application/json');

    if (!!token) {
      headers = headers.set('Authorization', 'Bearer ' + decodeURIComponent(token));
    }

    return headers;
  }
}
